import '@babel/polyfill';
import 'bam-browser-sdk';
import 'bam-browser-sdk-sdkSession-util';

console.log('Basesite');
